import { ComponentMap } from '@cinch-nx/data-storyblok'
import { FaqAccordion } from '@cinch-nx/landing-ui-shared'

export const storyblokComponents: ComponentMap = {
  FaqSection: FaqAccordion,
}
